import clsx from 'clsx'
import { Icon } from '@/components'
import {
  StatusAlert as StatusAlertModel,
  StatusAlertAction,
} from './ChargeForecastV2.types'

type Props = {
  alert: StatusAlertModel
  onAction: (action: StatusAlertAction) => void
}

export default function StatusAlert({ alert, onAction }: Props) {
  const isWarning = alert.variant === 'warning'

  return (
    <div
      id="charge-forecast-v2-alert"
      role="status"
      className={clsx(
        'box-border flex items-start w-full gap-2 p-4 rounded-[10px]',
        isWarning ? 'bg-themed-orange-100' : 'bg-themed-blue-100',
      )}
    >
      <span className="flex items-center justify-center w-5 h-5 shrink-0">
        <Icon
          name={isWarning ? 'AlertTriangle' : 'Info'}
          color={isWarning ? 'orange-500' : 'blue-500'}
          size={16}
          strokeWidth={1.5}
          aria-hidden
        />
      </span>
      <div className="flex flex-col flex-1 min-w-0 gap-2">
        <span
          className={clsx(
            'text-sm font-medium leading-5',
            isWarning ? 'text-themed-orange-500' : 'text-themed-blue-500',
          )}
        >
          {alert.message}
        </span>
        {alert.link && (
          <button
            id="charge-forecast-v2-alert-link"
            type="button"
            onClick={() => alert.link && onAction(alert.link.action)}
            className="self-start p-0 text-sm font-bold leading-6 underline bg-transparent border-0 cursor-pointer text-themed-blue-500"
          >
            {alert.link.text}
          </button>
        )}
      </div>
    </div>
  )
}
